exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._12cYb{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}._2L3Oy,._12cYb{display:-webkit-box;display:-ms-flexbox;display:flex}._2L3Oy{padding:4px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:10px;background:#fff;text-align:center;color:#000;border:1px solid #ffd906;border-radius:3px}.Eybs_{width:26px;margin:5px 2px 2px}._2-cmO{width:32px;margin:0 13px}", ""]);

// exports
exports.locals = {
	"root": "_12cYb",
	"mobileRoot": "_2L3Oy",
	"socialIcon": "Eybs_",
	"mobileSocIcon": "_2-cmO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/DealerSocials/DealerSocials.css
// module id = 2075
// module chunks = 15 17 32 36